export default __webpack_public_path__ + "static/media/amazonbk.18921740.jpg";